import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "category-levels-assessment__main"
}
const _hoisted_3 = { class: "category-levels-assessment__level-slider-column" }
const _hoisted_4 = {
  key: 0,
  class: "category-levels-assessment-level-slider-tip"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Drag Tip Icon",
  class: "category-levels-assessment-level-slider-tip__icon",
  src: "/img/arrow-tip.svg"
}, null, -1)
const _hoisted_6 = { class: "category-levels-assessment-level-slider-tip__text" }
const _hoisted_7 = { class: "category-levels-assessment__requirements-column" }
const _hoisted_8 = {
  key: 0,
  class: "category-levels-assessment-skip-tip"
}
const _hoisted_9 = { class: "category-levels-assessment-skip-tip__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelSlider = _resolveComponent("LevelSlider")!
  const _component_LevelsDescription = _resolveComponent("LevelsDescription")!
  const _component_CategoryRequirements = _resolveComponent("CategoryRequirements")!
  const _component_PxIcon = _resolveComponent("PxIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'is-navigation-bar': _ctx.$screen.mdOnly }, "category-levels-assessment"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.currentCategory && _ctx.selectedStep)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_LevelSlider, {
                color: _ctx.currentCategory.color,
                levels: _ctx.currentCategory.categoryDetails.length,
                value: _ctx.selectedStep.level,
                height: "393px",
                onInput: _ctx.onLevelChange
              }, null, 8, ["color", "levels", "value", "onInput"]),
              (_ctx.selectedStep.level === 0 && _ctx.isFirstInteraction)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("affiliateProgram.assessment.dragTip")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_LevelsDescription, {
              "category-details": _ctx.currentCategory.categoryDetails,
              "current-level": _ctx.selectedStep.level,
              class: "category-levels-assessment__levels-description",
              height: "342px"
            }, null, 8, ["category-details", "current-level"]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_CategoryRequirements, {
                category: _ctx.currentCategory,
                level: _ctx.selectedStep.level,
                class: "category-levels-assessment__category-requirements"
              }, null, 8, ["category", "level"]),
              (_ctx.selectedStep.level === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_PxIcon, {
                      size: 16,
                      name: "information"
                    }),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("affiliateProgram.assessment.noLevelTip")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}